var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetrics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_648_1319)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_648_1319",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_648_1319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7831 3.47007C21.1829 3.27938 20.5615 3.72801 20.5615 4.36345V9.89995C20.5593 10.2499 20.7543 10.5721 21.0532 10.7324C23.4889 12.0694 25.0017 14.6236 25.0017 17.3999C25.0017 21.5913 21.5918 25.0012 17.4004 25.0012C14.6242 25.0012 12.0699 23.4884 10.7329 21.0527C10.5754 20.7609 10.2595 20.561 9.90191 20.561H4.36391C3.74016 20.561 3.27584 21.1717 3.47078 21.7834C5.30903 27.6318 10.7895 31.9995 17.4004 31.9995C25.4693 31.9995 32 25.4699 32 17.3999C32 10.7964 27.6398 5.31063 21.7831 3.47007ZM16.4629 30.0902C11.6199 29.7409 7.55434 26.6857 5.71253 22.436H9.37297C10.9347 24.9232 13.5559 26.5411 16.4629 26.8294V30.0902ZM22.4365 9.37257V5.71207C26.6835 7.5527 29.7411 11.6165 30.0907 16.4624H26.8299C26.5416 13.5555 24.9238 10.9342 22.4365 9.37257ZM18.3379 30.0899V26.8299C22.8163 26.388 26.3885 22.8157 26.8304 18.3374H30.0904C29.6315 24.608 24.6085 29.631 18.3379 30.0899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4004 0C7.78375 0 0 7.78244 0 17.4004C0 17.9181 0.41975 18.3379 0.9375 18.3379H17.4004C17.9181 18.3379 18.3379 17.9181 18.3379 17.4004V0.9375C18.3379 0.41975 17.9181 0 17.4004 0ZM16.4629 16.4629H1.90262C2.36575 8.63738 8.62806 2.36631 16.4629 1.90262V16.4629Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_1319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetrics);
export default __webpack_public_path__ + "static/media/metrics.dd8384dafef68b02fc12779d873a15c4.svg";
export { ForwardRef as ReactComponent };